module.exports = __webpack_public_path__ + "static/media/undraw_upload_image_iwej.0e590027.svg";